import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CommissionFisofo} from '../../model/commission-fisofo';
import {CatalogModel} from '../../../app/model/other-catalogs-models';
import {CatEmployeeJobService} from 'src/app/services/cat-employee-job.service';
import {UtilitiesService} from 'src/app/services/utilities.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {isNullOrUndefined} from 'util';
import {catchError, tap} from 'rxjs/operators';
import {forkJoin, of, throwError} from 'rxjs';
import {CommissionFisofoService} from 'src/oldApp//services/commission-fisofo.service';

@Component({
  selector: 'app-modal-commission-fisofo-configuration',
  templateUrl: './modal-commission-fisofo-configuration.component.html',
  styleUrls: ['./modal-commission-fisofo-configuration.component.css']
})
export class ModalCommissionFisofoConfigurationComponent implements OnInit {

  @Input() commissionFisofo:CommissionFisofo;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public valid:boolean=false;
  public error:boolean=false;
  public viewStatus:number=1;
  public formIsLocked:boolean=false;
  public details:string=null;
  public title:string=null;
  public hiddenRate:boolean=false;
  public confirmTitle:string='<i class="icon-info-circled"></i>&nbsp;&nbsp;Ha ingresado la siguiente información. Está seguro de guardar?';

  // catalogos
  public listCommissions:CommissionFisofo[]=[];
  public listCommissionsFiltered:CommissionFisofo[]=[];

  public commissionGroupCatalog:CatalogModel[]=[];
  public businessProductsCatalog:CatalogModel[]=[];
  public ownerTypesCatalog:CatalogModel[]=[];
  public productsCatalog:CatalogModel[]=[];
  public afiliatesCatalog:CatalogModel[]=[];
  public paymentTermsCatalog:CatalogModel[]=[];

  public selectedCommissionGroupDD:string[]=[];
  public selectedBusinessProductsDD:string[]=[];
  public selectedOwnerTypesDD:any[]=[];
  public selectedProductsDD:any[] = [];
  public selectedAfiliatesDD:any[]=[];
  public selectedPaymentTermsDD:any[]=[];

  public selectedCommissionGroup:any[]=[];
  public selectedBusinessProducts:any[]=[];
  public selectedOwnerTypes:any[]=[];
  public selectedProducts:any[] = [];
  public selectedAfiliates:any[]=[];
  public selectedPaymentTerms:any[]=[];

  // mascaras
  public customPatterns={
    '0':{pattern:new RegExp('-|[0-9]')},
    '9':{pattern:new RegExp('[0-9]')},
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                         // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},     // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  constructor(
    private commissionFisofoService:CommissionFisofoService,
    private utils:UtilitiesService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    console.log(">>> this.commissionFisofo= ", this.commissionFisofo);

    if(this.mode === "edit" && this.commissionFisofo.commissionId != null && this.commissionFisofo.commissionId > 0) {
      this.title = '<i class="icon-pencil"></i>&nbsp;&nbsp;Editar Comisión';
      this.getCatalogs(this.commissionFisofo.commissionId);
    }

    if(this.mode==='create') {
      this.title = '<i class="icon-plus"></i>&nbsp;&nbsp;Crear Comisines';
      this.getCatalogs(0);
    }

    if(this.mode==='detail' || this.mode==='delete' || this.mode==="toggleActive") {
      if(this.mode==='detail') this.confirmTitle = '<i class="icon-eye"></i>&nbsp;&nbsp;Detalle de Comisión';
      if(this.mode==='delete') this.confirmTitle = '<i class="icon-attention"></i>&nbsp;&nbsp;Se eliminará el siguiente registro. Esta seguro de eliminar?';
      if(this.mode==='toggleActive') {
        this.toggleActive();
        this.confirmTitle = this.commissionFisofo.activeId ? '<i class="icon-attention"></i>&nbsp;&nbsp;Se activará el siguiente registro. Esta seguro de activar?' : '<i class="icon-attention"></i>&nbsp;&nbsp;Se desactivará el siguiente registro. Esta seguro de desactivar?';
      }
      this.details = this.getDetails();
      this.viewStatus = 2;
    }

    let modalContent:any = $('.modal-content');
    modalContent.draggable({
      handle: '.card-header'
      // , drag: function() {
      //   document.querySelector<HTMLElement>(".card-modal").classList.add("backdrop-modal");
      // }
    });
  }

  isValid=()=> {
    this.valid = true;

    let errors=[];
    if(this.commissionGroupError()) errors.push('&bull; Seleccione un grupo de puesto!');
    if(this.productError()) errors.push('&bull; Seleccione un producto!');
    if(this.afiliateError()) errors.push('&bull; Seleccione un convenio!');
    if(this.paymentTermError()) errors.push('&bull; Seleccione un plazo!');
    if(this.rateMinError()) errors.push('&bull; Ingrese una tasa mínima!');
    if(this.rateMaxError()) errors.push('&bull; Ingrese una tasa máxima!');
    if(this.rateMinMaxError()) errors.push('&bull; La tasa mínima no puede ser mayor a la tasa máxima!');
    if(this.commissionError()) errors.push('&bull; Ingrese una comisión de ' + (this.commissionFisofo.commissionGroupId === 1 ? 'asesor' : 'aliado comercial') + '!');
    if(this.commissionManagerError()) errors.push('&bull; Ingrese una comisión de gerente!');
    if(this.commissionRegionalError()) errors.push('&bull; Ingrese una comisión de regional!');
    if(this.commissionCoordinatorError()) errors.push('&bull; Ingrese una comisión de coordinador!');
    // if(this.advanceMinError()) errors.push('&bull; Ingrese un avance mínimo!');
    // if(this.advanceMaxError()) errors.push('&bull; Ingrese un avance máximo!');
    // if(this.advanceMinMaxError()) errors.push('&bull; El avance mínimo no puede ser mayor al avance máximo!');
    // if(this.collectCapitalAmountMinError()) errors.push('&bull; Ingrese un monto colocado mínimo!');
    // if(this.collectCapitalAmountMaxError()) errors.push('&bull; Ingrese un monto colocado máximo!');
    // if(this.collectCapitalAmountMinMaxError()) errors.push('&bull; El monto capital mínimo no puede ser mayor al monto máximo!');

    if(errors.length>0) {
      this.valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }

    if(this.valid){
      this.details = this.getDetails();
      this.viewStatus = 2;
    }else{
      this.viewStatus = 1;
      this.details = null;
    }
  }
  getDetails=()=> {
    let details = "<table cellpadding=\"4\">";

    if(this.commissionFisofo.commissionGroupId === 1 )
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión Asesor:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.commission + "%]</td></tr>";

    if(this.commissionFisofo.commissionGroupId === 4 )
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión Aliado Comercial:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.commission + "%]</td></tr>";

    if(this.commissionFisofo.commissionGroupId === 2 ) {
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión Gerente:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.commissionManager + "%]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión Regional:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.commissionRegional + "%]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión Coordinador:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.commissionCoordinator + "%]</td></tr>";
    }

    /*if(this.commissionFisofo.commissionGroupId === 3 ) {
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión Gerente:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.commissionManager + "%]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión Regional:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.commissionRegional + "%]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Comisión Coordinador:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.commissionCoordinator + "%]</td></tr>";
    }*/

    //details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Avance:</font></b></td><td valign=\"top\">De [" + this.commissionFisofo.advanceMin + "%] a [" + this.commissionFisofo.advanceMax + "%]</td></tr>";
    details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Tasa:</font></b></td><td valign=\"top\">De [" + (this.commissionFisofo.rateMin != null ? this.commissionFisofo.rateMin : '0') + "%] a [" + (this.commissionFisofo.rateMax != null ? this.commissionFisofo.rateMax : '0') + "%]</td></tr>";

    if(this.mode === "edit" || this.mode === "create") {
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Grupo Puesto:</font></b></td><td valign=\"top\">[" + this.getSelectedCommissionGroup() + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Producto:</font></b></td><td valign=\"top\">[" + this.getSelectedProducts() + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenio:</font></b></td><td valign=\"top\">[" + this.getSelectedAfiliates() + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazo:</font></b></td><td valign=\"top\">[" + this.getSelectedPaymentTerms() + "]</td></tr>";
    }else{
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Grupo Puesto:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.commissionGroupDescr + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Producto:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.financingTypeDescr + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Convenio:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.afiliateDescr + "]</td></tr>";
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Plazo:</font></b></td><td valign=\"top\">[" + this.commissionFisofo.paymentDescr + "]</td></tr>";
    }

    if(this.mode==='detail' || this.mode==='delete')
      details = details + "<tr><td valign=\"top\" align=\"left\" width=\"200\"><b><font color=\"#5a5c69\">&bull;&nbsp;&nbsp;Activo:</font></b></td><td valign=\"top\">" + (this.commissionFisofo.activeId ? '[Sí]' : '[No]') + "</td></tr>";

    details = details + "</table>";
    return details;
  }

  closeConfirm=()=> {
    if(this.mode==="delete" || this.mode==="toggleActive" || this.mode==="detail"){
      this.modalService.dismissAll();
    }else{
      this.viewStatus = 1;
      this.details = null;
    }
  }

  save=()=> {
    if(this.error){
      this.modalService.dismissAll('failure');
      return;
    }

    this.viewStatus=0;
    delete this.commissionFisofo.financingTypeDescr;
    delete this.commissionFisofo.afiliateDescr;
    delete this.commissionFisofo.paymentDescr;
    delete this.commissionFisofo.commissionGroupDescr;
    delete this.commissionFisofo.createUserId;
    delete this.commissionFisofo.createUserName;
    delete this.commissionFisofo.createDate;
    delete this.commissionFisofo.modifUserName;
    delete this.commissionFisofo.modifDate;

    if(this.mode==="delete" || this.mode==="toggleActive"){

      this.commissionFisofo.modifUserId=Number(localStorage.getItem('com_token'));

      if(this.mode==="delete"){
        this.commissionFisofoService.delete(this.commissionFisofo)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El registro se ha eliminado correctamente!');
            }
            if(resp && resp.codeHttpStatus===409) {
              this.confirmTitle='<i class="icon-attention"></i>&nbsp;&nbsp; Error al eliminar!';
              this.details = '<h6>No se pude eliminar el registro seleccionado debido a reglas de negocio!</h6>';
              this.error = true;
            }
          });
      }

      if(this.mode==="toggleActive"){
        let status = this.commissionFisofo.activeId ? 'activado' : 'desactivado';
        this.commissionFisofoService.saveUpdate(this.commissionFisofo)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.modalService.dismissAll('success');
              this.toastr.success('El registro se ha ' + status + ' correctamente!');
            }
          });
      }
    }

    if(this.mode==="create" || this.mode==="edit"){

      this.commissionFisofo.commission = !isNullOrUndefined(this.commissionFisofo.commission) ? this.commissionFisofo.commission : 0;
      this.commissionFisofo.commissionMax = !isNullOrUndefined(this.commissionFisofo.commissionMax) ? this.commissionFisofo.commissionMax : 0;
      this.commissionFisofo.commissionManager = !isNullOrUndefined(this.commissionFisofo.commissionManager) ? this.commissionFisofo.commissionManager : 0;
      this.commissionFisofo.commissionCoordinator = !isNullOrUndefined(this.commissionFisofo.commissionCoordinator) ? this.commissionFisofo.commissionCoordinator : 0;
      this.commissionFisofo.commissionRegional = !isNullOrUndefined(this.commissionFisofo.commissionRegional) ? this.commissionFisofo.commissionRegional : 0;

      this.commissionFisofo.advanceMin = !isNullOrUndefined(this.commissionFisofo.advanceMin) ? this.commissionFisofo.advanceMin : 0;
      this.commissionFisofo.advanceMax = !isNullOrUndefined(this.commissionFisofo.advanceMax) ? this.commissionFisofo.advanceMax : 0;

      this.commissionFisofo.rateMin = !isNullOrUndefined(this.commissionFisofo.rateMin) ? this.commissionFisofo.rateMin : 0;
      this.commissionFisofo.rateMax = !isNullOrUndefined(this.commissionFisofo.rateMax) ? this.commissionFisofo.rateMax : 0;

      this.commissionFisofo.collectCapitalAmountMin = !isNullOrUndefined(this.commissionFisofo.collectCapitalAmountMin) ? this.commissionFisofo.collectCapitalAmountMin : 0;
      this.commissionFisofo.collectCapitalAmountMax = !isNullOrUndefined(this.commissionFisofo.collectCapitalAmountMax) ? this.commissionFisofo.collectCapitalAmountMax : 0;

      if(this.mode === 'edit' && this.commissionFisofo.commissionId != null && this.commissionFisofo.commissionId > 0){
        this.commissionFisofo.modifUserId = Number(localStorage.getItem('com_token'));
        console.log(">> this.commissionFisofo=", this.commissionFisofo);
        this.saveCommission(this.commissionFisofo);
      }
      if(this.mode === 'create'){
        this.commissionFisofo.createUserId = Number(localStorage.getItem('com_token'));
        console.log(">> this.commissionFisofo=", this.commissionFisofo);
        let request = {
          "commissionGroupId": this.commissionFisofo.commissionGroupId,
          "commission": this.commissionFisofo.commission,
          "commissionMax": this.commissionFisofo.commissionMax,
          "commissionManager": this.commissionFisofo.commissionManager,
          "commissionCoordinator": this.commissionFisofo.commissionCoordinator,
          "commissionRegional": this.commissionFisofo.commissionRegional,
          "advanceMin": this.commissionFisofo.advanceMin,
          "advanceMax": this.commissionFisofo.advanceMax,
          "rateMin": this.commissionFisofo.rateMin,
          "rateMax": this.commissionFisofo.rateMax,
          "collectCapitalAmountMin": this.commissionFisofo.collectCapitalAmountMin,
          "collectCapitalAmountMax": this.commissionFisofo.collectCapitalAmountMax,
          "createUserId": this.commissionFisofo.createUserId,
          "listFinancingTypes": this.selectedProducts.map(function(row) {
            return row.id;
          }),
          "listPaymentTerms": this.selectedPaymentTerms.map(function(row) {
            return row.id;
          }),
          "listAfiliates": this.selectedAfiliates.map(function(row) {
            return row.id;
          })
        };
        this.saveNewCommissions(request);
      }
    }
  }
  saveCommission=(model:CommissionFisofo)=>{
    this.commissionFisofoService.saveUpdate(model)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> saveRequest >> response=", resp);
          if(resp.data != null && resp.codeHttpStatus === 200){
            this.commissionFisofo.commissionId = resp.data.commissionId;
            this.modalService.dismissAll('success');
            this.toastr.success('La comisión se guardó correctamente!');
          }else{
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar...'));
          }
        }),
        catchError(error=> {
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al intentar guardar...'));
        })
      )
      .subscribe();
  }
  saveNewCommissions=(request:any)=>{
    console.log("----------------------------------------------------------------------------------------");
    console.log(request);
    console.log("----------------------------------------------------------------------------------------");
    this.commissionFisofoService.saveUpdateNew(request)
      .pipe(
        tap((resp:any)=> {
          console.log(">>> saveRequest >> response=", resp);
          if(resp.data != null && resp.codeHttpStatus === 200){
            this.modalService.dismissAll('success');
            this.toastr.success('Las comisiones se guardaron correctamente!');
          }else{
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar...'));
          }
        }),
        catchError(error=> {
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al intentar guardar...'));
        })
      )
      .subscribe();
  }
  close=()=> {
    this.modalService.dismissAll('cancel');
  }

  // HELPERS
  commissionGroupError=()=> !(this.selectedCommissionGroup != null && this.selectedCommissionGroup.length > 0);
  productError=()=> !(this.selectedProducts != null && this.selectedProducts.length > 0);
  afiliateError=()=> !(this.selectedAfiliates != null && this.selectedAfiliates.length > 0);
  paymentTermError=()=> !(this.selectedPaymentTerms != null && this.selectedPaymentTerms.length > 0);
  commissionError=()=> (this.commissionFisofo.commissionGroupId === 1 || this.commissionFisofo.commissionGroupId === 4) ? isNullOrUndefined(this.commissionFisofo.commission) : false;

  //TERCIA
  commissionManagerError=()=> this.commissionFisofo.commissionGroupId === 2 ? isNullOrUndefined(this.commissionFisofo.commissionManager) : false
  commissionRegionalError=()=> this.commissionFisofo.commissionGroupId === 2 ? isNullOrUndefined(this.commissionFisofo.commissionRegional) : false
  commissionCoordinatorError=()=> this.commissionFisofo.commissionGroupId === 2 ? isNullOrUndefined(this.commissionFisofo.commissionCoordinator) : false;

  commissionMaxError=()=> this.commissionFisofo.commissionMax!==0 && !this.commissionFisofo.commissionMax;
  advanceMinError=()=> isNullOrUndefined(this.commissionFisofo.advanceMin);
  advanceMaxError=()=> isNullOrUndefined(this.commissionFisofo.advanceMax);
  advanceMinMaxError=()=> !isNullOrUndefined(this.commissionFisofo.advanceMin) &&
    !isNullOrUndefined(this.commissionFisofo.advanceMax) && (
      this.commissionFisofo.advanceMin > this.commissionFisofo.advanceMax
    );

  rateMinError=()=> !this.hiddenRate && isNullOrUndefined(this.commissionFisofo.rateMin);
  rateMaxError=()=> !this.hiddenRate && isNullOrUndefined(this.commissionFisofo.rateMax);
  rateMinMaxError=()=> !isNullOrUndefined(this.commissionFisofo.rateMin) &&
    !isNullOrUndefined(this.commissionFisofo.rateMax) && (
      this.commissionFisofo.rateMin > this.commissionFisofo.rateMax
    );

  collectCapitalAmountMinError=()=> isNullOrUndefined(this.commissionFisofo.collectCapitalAmountMin);
  collectCapitalAmountMaxError=()=> isNullOrUndefined(this.commissionFisofo.collectCapitalAmountMax);
  collectCapitalAmountMinMaxError=()=> !isNullOrUndefined(this.commissionFisofo.collectCapitalAmountMin) &&
    !isNullOrUndefined(this.commissionFisofo.collectCapitalAmountMax) && (
      this.commissionFisofo.collectCapitalAmountMin > this.commissionFisofo.collectCapitalAmountMax
    );

  compare(a:any, b:any) {
    const arr = [];
    return arr.indexOf(a.id) - arr.indexOf(b.id);
  }
  updateCommission=e=> this.commissionFisofo.commission=!e || e.trim()===''?null:Number(e);
  updateCommissionManager=e=> this.commissionFisofo.commissionManager=!e || e.trim()===''?null:Number(e);
  updateCommissionRegional=e=> this.commissionFisofo.commissionRegional=!e || e.trim()===''?null:Number(e);
  updateCommissionCoordinator=e=> this.commissionFisofo.commissionCoordinator=!e || e.trim()===''?null:Number(e);
  updateCommissionMax=e=> this.commissionFisofo.commissionMax=!e || e.trim()===''?null:Number(e);
  updateAdvanceMin=e=> this.commissionFisofo.advanceMin=!e || e.trim()===''?null:Number(e);
  updateAdvanceMax=e=> this.commissionFisofo.advanceMax=!e || e.trim()===''?null:Number(e);
  updateRateMin=e=> this.commissionFisofo.rateMin=!e || e.trim()===''?null:Number(e);
  updateRateMax=e=> this.commissionFisofo.rateMax=!e || e.trim()===''?null:Number(e);
  updateCollectCapitalAmountMin=e=> this.commissionFisofo.collectCapitalAmountMin=!e || e.trim()===''?null:Number(e);
  updateCollectCapitalAmountMax=e=> this.commissionFisofo.collectCapitalAmountMax=!e || e.trim()===''?null:Number(e);

  toggleActive=()=> this.commissionFisofo.activeId=!this.commissionFisofo.activeId;
  getSelectedCommissionGroup=()=>{
    let value:string = '';
    this.selectedCommissionGroup.forEach(function(group){
      value = value + group.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }
  getSelectedProducts=()=>{
    let value:string = '';
    this.selectedProducts.forEach(function(emp){
      value = value + emp.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }
  getSelectedAfiliates=()=>{
    let value:string = '';
    this.selectedAfiliates.forEach(function(emp){
      value = value + emp.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }
  getSelectedPaymentTerms=()=>{
    let value:string = '';
    this.selectedPaymentTerms.forEach(function(emp){
      value = value + emp.description + ", ";
    });
    value = value.substring(0,value.length-2);
    return value;
  }

  // EVENTS
  commissionGroupChange=e=> {
    if(e.length > 0){
      this.selectedCommissionGroup=e;
      this.commissionFisofo.commissionGroupId=e[0].id;
      this.selectedCommissionGroupDD=e.map(function(e){
        return parseInt(e.id);
      });

      console.log(">> this.selectedCommissionGroup= ", this.selectedCommissionGroup);
      console.log(">> this.selectedCommissionGroupDD= ", this.selectedCommissionGroupDD);

      this.commissionFisofo.commission = null;
      this.commissionFisofo.commissionManager = null;
      this.commissionFisofo.commissionCoordinator = null;
      this.commissionFisofo.commissionRegional = null;
    } else {
      this.selectedCommissionGroup=[];
    }
  };
  productsChange=e=> {
    this.selectedAfiliates=[];
    this.selectedPaymentTerms=[];

    this.selectedAfiliatesDD=[];
    this.selectedPaymentTermsDD=[];

    if(e.length > 0){
      this.selectedProducts=e;
      console.log(">> this.selectedProducts= ", this.selectedProducts);
      console.log(">> this.selectedProductsDD= ", this.selectedProductsDD);

      //CARGA CONVENIOS X PRODUCTOS SELECCIONADOS
      if(this.selectedProducts != null && this.selectedProducts.length > 0){

        this.afiliatesCatalog=[];
        this.paymentTermsCatalog=[];

        let financingTypeId:number[]=[];
        this.selectedProducts.forEach((el)=>{
          financingTypeId.push(el.id);
        });

        this.commissionFisofoService.getAfiliatesByProduct(financingTypeId)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.afiliatesCatalog=resp.data.filter(item => item.id > 0);
            }
          });
      }
    }else{
      this.selectedProducts=[];
    }
  }
  afiliatesChange=e=> {

    this.selectedPaymentTerms=[];
    this.selectedPaymentTermsDD=[];

    if(e.length > 0) {
      this.selectedAfiliates = e;
      this.selectedAfiliatesDD=e.map(function(e){
        return parseInt(e.id);
      });

      console.log(">> this.selectedAfiliates= ", this.selectedAfiliates);
      console.log(">> this.selectedAfiliatesDD= ", this.selectedAfiliatesDD);

      //CARGAR PLAZOS X CONVENIOS SELECCIONADOS
      if(this.selectedAfiliates != null && this.selectedAfiliates.length > 0){

        this.paymentTermsCatalog=[];
        this.commissionFisofo.rateMin = null;
        this.commissionFisofo.rateMax = null;

        let afiliates:number[]=[];
        this.selectedAfiliates.forEach((el)=>{
          if(el.id > 0) {
            afiliates.push(el.id);
            if(el.id === 2 || el.id === 4){ //IMSS Y GDF
              this.hiddenRate = true;
            } else {
              this.hiddenRate = false;
            }
          }
        });

        this.commissionFisofoService.getPaymentTermsByAfiliate(afiliates)
          .subscribe((resp:any)=> {
            if(resp && resp.codeHttpStatus===200) {
              this.paymentTermsCatalog=resp.data.filter(e => e.id!==21 && e.id!==22 && e.id!==23);
            }
          });
      }
    }else{
      this.selectedAfiliates = [];
    }
  }
  paymentTermsChange=e=> {
    if(e.length > 0) {
      this.selectedPaymentTerms = e;
      console.log(">> this.selectedPaymentTerms= ", this.selectedPaymentTerms);
      console.log(">> this.selectedPaymentTermsDD= ", this.selectedPaymentTermsDD);
    } else {
      this.selectedPaymentTerms = [];
    }
  }

  // INFO
  getCatalogs=(commissionSaleId:number)=> {
    this.viewStatus=0;
    forkJoin(
      this.commissionFisofoService.getCommissionGroups(),   //Puestos
      this.commissionFisofoService.getProducts(),  //Productos
    )
      .pipe(
        tap(([comGroupResp, prodResp]:[any, any])=> {
          if(comGroupResp && prodResp) {

            this.commissionGroupCatalog=comGroupResp.data.filter(e=> e.id !== 3);
            //this.commissionGroupCatalog=comGroupResp.data;/*.filter(e=> e.employeeJobId > 0).map(function(row) {
            //  return { id : row.employeeJobId, description : row.description }
            //});*/

            this.productsCatalog = prodResp.data;

            if(commissionSaleId > 0){
              let listProd:number[]=[];
              let listAfi:number[]=[];

              let idEmpGroup:number = parseInt(this.commissionFisofo.commissionGroupId.toString());
              let idProd:number = parseInt(this.commissionFisofo.financingTypeId.toString());
              let idAfi:number = parseInt(this.commissionFisofo.afiliateId.toString());
              let idPay:number = parseInt(this.commissionFisofo.paymentId.toString());

              listProd.push(idProd);
              listAfi.push(idAfi);

              this.selectedCommissionGroup=comGroupResp.data.filter(e=> e.id===idEmpGroup);
              this.selectedCommissionGroupDD=comGroupResp.data.filter(e=> e.id===idEmpGroup).map(function(e){
                return parseInt(e.id);
              });

              this.selectedProducts=prodResp.data.filter(e=> e.id===idProd);
              this.selectedProductsDD=prodResp.data.filter(e=> e.id===idProd).map(function(e){
                return parseInt(e.id);
              });

              this.loadAfiliates(listProd, idAfi);
              this.loadPaymentTerms(listAfi, idPay);

            }else{
              this.viewStatus=1;
            }
          }
          else throwError;
        }),
        catchError(error=> {
          //console.log(error);
          this.viewStatus=-1;
          return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
        })
      )
      .subscribe();
  }
  loadAfiliates=(financingTypeId:number[], idAfi:number)=>{
    if(financingTypeId != null && idAfi != null){
      this.commissionFisofoService.getAfiliatesByProduct(financingTypeId)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.afiliatesCatalog=resp.data;
            this.selectedAfiliates=resp.data.filter(e=> e.id===idAfi);
            this.selectedAfiliatesDD=resp.data.filter(e=> e.id===idAfi).map(function(e){
              return parseInt(e.id);
            });
          }
        });
    }
  }
  loadPaymentTerms=(afiliateId:number[], idPay:number)=>{
    if(afiliateId != null && idPay != null){
      this.commissionFisofoService.getPaymentTermsByAfiliate(afiliateId)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.paymentTermsCatalog=resp.data;
            this.selectedPaymentTerms=resp.data.filter(e=> e.id===idPay);
            this.selectedPaymentTermsDD=resp.data.filter(e=> e.id===idPay).map(function(e){
              return parseInt(e.id);
            });
            this.viewStatus=1;
          }
        });
    }
  }

}
